export function* idFactory(
  { negatives, bigNumber } = { negatives: false, bigNumber: false }
) {
  let index = negatives ? -1 : 1;
  if (bigNumber) index = 9999999;
  if (negatives) {
    for (;;) {
      index -= 1;
      yield index;
    }
  } else {
    for (;;) {
      index += 1;
      yield index;
    }
  }
}

export default { idFactory };
